import marked from 'marked';

/**
 * @param {string} md
 * @param {object} [opts]
 * @param {boolean} [opts.sanitize=true]
 * @param {boolean} [opts.headerIds=false]
 * @returns {string}
 */
export const md2html = (md = '', opts = {}) => marked(md, {
  sanitize: true,
  headerIds: false,
  ...opts,
});

/**
 * @param {string} html
 * @param {object} [opts]
 * @param {boolean} [opts.stripHeadersContent=false]
 * @returns {string}
 */
export const stripTags = (html = '', { stripHeadersContent = false } = {}) => {
  let retVal = html;

  retVal = stripHeadersContent ? retVal.replace(/<(h[1-6]+)[^>]*?>.+?<\/\1>/gi, '') : retVal;
  return retVal.replace(/<[^>]+>/gi, '');
};

/**
 * @param {string} md
 * @param {object} [opts]
 * @param {boolean} [opts.stripHeadersContent=false]
 * @param {boolean} [opts.sanitize=true]
 * @param {boolean} [opts.headerIds=false]
 * @returns {string}
 * @todo change `md2html |> stripTags` to ease alternative
 */
export const stripMarkdown = (md = '', opts = {}) => stripTags(md2html(md, opts), opts);
